import React, { useState, useEffect } from 'react'
import { domToReact } from 'html-react-parser'
import { useParams } from 'react-router-dom'

import { useAwards } from 'data/hooks'
import { Award } from './award'


export const AmazonRedim = props => {

  const awardType = props.attribs['data-awardtype']
  const allowRedim = props.attribs['data-allowredim']

  const gameId = useParams().gameId || playmotiv.game.gameId
  const { eventId } = useParams()
  const { events, awards } = useAwards(gameId)
  const [ isLoading, loading ] = useState(false)

  const awardsOfType = awards.filter(award => award.awardType === awardType)
                            .map(award => {
                              return {
                                ...award,
                                event: Object.values(events)
                                            .find(event => 
                                              event.awards.find(eventAward => eventAward.awardId === award.awardId)
                                            )
                              }
                            })
                            .filter(award => (award.event && award.event.eventId == eventId) || !eventId)
                            .sort((a, b) => {
                              if (a.event.eventOrder > b.event.eventOrder) return 1
                              if (a.event.eventOrder < b.event.eventOrder) return -1
                              if (a.awardDate > b.awardDate) return 1
                              if (a.awardDate < b.awardDate) return -1
                              return 0
                            })

  // console.log(awardsOfType)

  

  return (<>
    { isLoading ? 
        <>...</>
      :
      <div className="amazonredim">

        { awardsOfType.length > 0 ?

            <div className="awards-wrapper">

              <div className={`header`}>
                <div className="award-title">Premio</div>
                <div className="value">Valor</div>
                {
                  allowRedim == 'true' && <div className="redim"></div>
                }
              </div>
  
              { awardsOfType.map((award, index) =>               
                  <Award key={index} award={award} allowRedim={allowRedim} eventId={eventId} /> 
                )
              }

            </div>

          : domToReact(props.children)
        }
      </div>
    }
  </>)
}
